import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocale } from '../../i18n/locale-context.js';
function formatRemaining(seconds, t) {
    if (seconds <= 0)
        return t('recovery.cooling_off.ready');
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    if (hours >= 24) {
        const days = Math.floor(hours / 24);
        const remHours = hours % 24;
        return t('recovery.cooling_off.remaining_template_days', { days, hours: remHours });
    }
    return t('recovery.cooling_off.remaining_template_hours', { hours, minutes });
}
export function RecoveryCoolingOffStep(props) {
    const { t } = useLocale();
    return (_jsxs("section", { "aria-labelledby": "cool-off-heading", children: [_jsx("h3", { id: "cool-off-heading", children: t('recovery.cooling_off.heading') }), _jsx("p", { children: t('recovery.cooling_off.body') }), _jsx("p", { children: _jsxs("strong", { children: [t('recovery.cooling_off.tier_label'), ' ', t(`recovery.tier_election.option.${props.tier}.label`)] }) }), _jsxs("p", { children: [_jsx("strong", { children: t('recovery.cooling_off.time_remaining_label') }), ' ', formatRemaining(props.secondsRemaining, t)] }), _jsx("p", { children: _jsxs("small", { children: [t('recovery.cooling_off.cool_off_until_label'), ' ', _jsx("code", { children: props.coolOffUntil })] }) }), _jsx("p", { children: _jsx("em", { children: t('recovery.cooling_off.disclosure') }) })] }));
}
//# sourceMappingURL=cooling-off-step.js.map